﻿/*
 * @class rlDynamicPhone
 * @memberOf jQuery.fn
 */
(function ($) {
  var dynamicPhoneUpdateTriggered = false;
  $.fn.rlDynamicPhone = function (url, cookie) {

    var config = {
      cookieName: cookie,
      apiUrl: url,
      phoneNumberId: ".dynamicPhoneNumber",
      loadedCodeId: ".hidLoadedCode"
    }

    function getChangedCode() {
      var loadedCode = $(config.loadedCodeId).first().val();
      
      //check if the loaded code is different from the cookie value
      var cookieCode = getRlCampaignCodeCookieValue();
      if (cookieCode && cookieCode.toLowerCase() !== loadedCode.toLowerCase()) {
        return cookieCode;
      }

      return false;
    }

    function updateDynamicPhoneNumber(code) {
      if (!dynamicPhoneUpdateTriggered) {
        //get the phone number from the api and update the blocks
        var $phoneNumberBlocks = $(config.phoneNumberId);
        var params = { code: code };

        $.ajax({
          type: 'POST',
          dataType: "json",
          url: config.apiUrl,
          data: params,
          success: function(data) {
            if (data && data.number) {
              $phoneNumberBlocks.html(data.number);
              $phoneNumberBlocks.attr("href", "tel:" + data.number);
            }
          }
        });
      }
      dynamicPhoneUpdateTriggered = true;
    }

    function getRlCampaignCodeCookieValue() {
      //look for the cookie and get the value
      var regex = new RegExp('(?:^|;)\\s?' + config.cookieName + '=(.*?)(?:;|$)', 'i');
      var result = document.cookie.match(regex);
      return (result === null) ? null : unescape(result[1]);
    }

    function processDynamicPhoneNumber() {
      //check if the code has changed and run the ajax call if it has
      var changedCode = getChangedCode();
      if (changedCode) {
        updateDynamicPhoneNumber(changedCode);
      }
    }

    //run the process
    processDynamicPhoneNumber();
  }
}(jQuery));